/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Provider_AmazonInputs */

const en_voice_manager_provider_amazon = /** @type {(inputs: Voice_Manager_Provider_AmazonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amazon`)
};

const fr_voice_manager_provider_amazon = /** @type {(inputs: Voice_Manager_Provider_AmazonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amazon`)
};

const de_voice_manager_provider_amazon = /** @type {(inputs: Voice_Manager_Provider_AmazonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amazonas`)
};

const it_voice_manager_provider_amazon = /** @type {(inputs: Voice_Manager_Provider_AmazonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amazzonia`)
};

const ru_voice_manager_provider_amazon = /** @type {(inputs: Voice_Manager_Provider_AmazonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amazon`)
};

const es_voice_manager_provider_amazon = /** @type {(inputs: Voice_Manager_Provider_AmazonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amazonas`)
};

const zh_cn2_voice_manager_provider_amazon = /** @type {(inputs: Voice_Manager_Provider_AmazonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`亚马逊`)
};

const ja_voice_manager_provider_amazon = /** @type {(inputs: Voice_Manager_Provider_AmazonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アマゾン`)
};

const hi_voice_manager_provider_amazon = /** @type {(inputs: Voice_Manager_Provider_AmazonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीरांगना`)
};

const pt_pt2_voice_manager_provider_amazon = /** @type {(inputs: Voice_Manager_Provider_AmazonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amazon`)
};

/**
* | output |
* | --- |
* | "Amazon" |
*
* @param {Voice_Manager_Provider_AmazonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_provider_amazon = /** @type {((inputs?: Voice_Manager_Provider_AmazonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Provider_AmazonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_voice_manager_provider_amazon(inputs)
	if (locale === "de") return de_voice_manager_provider_amazon(inputs)
	if (locale === "it") return it_voice_manager_provider_amazon(inputs)
	if (locale === "ru") return ru_voice_manager_provider_amazon(inputs)
	if (locale === "es") return es_voice_manager_provider_amazon(inputs)
	if (locale === "zh-CN") return zh_cn2_voice_manager_provider_amazon(inputs)
	if (locale === "ja") return ja_voice_manager_provider_amazon(inputs)
	if (locale === "hi") return hi_voice_manager_provider_amazon(inputs)
	if (locale === "pt-PT") return pt_pt2_voice_manager_provider_amazon(inputs)
	return en_voice_manager_provider_amazon(inputs)
});